module.exports = __webpack_public_path__ + "static/media/tree_18.6265e5e3.jpg";